export default "__VITE_ASSET__DST$5JdP__"